/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import dayjs from 'dayjs';

import { useFormik } from 'formik';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { listReqTechs, unloadReqTechs } from '../../modules/techModule/techReqs';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';

import TechList from '../../components/techSupports/TechList';
import TechReqStatusList from '../../components/techSupports/TechReqStatusList';
import TechReqStatusChip from '../../components/common/datagrid/TechReqStatusChip';
import { TechReqListBox } from '../../components/techSupports/TechReqListBox';

const ReqTechListContainer = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  // 홈 위젯(내 담당 기술지원 요청)에서 ?workEmp=/&openOnly=Y 로 들어오면 그 필터로 초기
  // 조회한다 - 카드=목록 건수를 맞추기 위한 최소 딥링크 지원(메인화면 재검토, 2026-10-23).
  const [searchParams] = useSearchParams();

  const [searchGrade, setSearchGrade] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("custNm");
  const [searchWords, setSearchWords] = useState(null);
  const [searchStrtDt, setSearchStrtDt] = useState('');
  const [searchEndDt, setSearchEndDt] = useState('')
  // 딥링크 필터는 state로 한 번만 읽어서 searchList()가 호출될 때마다(마운트 포함) 같이 실어
  // 보낸다 - 아래 "마운트 시 dispatch(listReqTechs())" 와 searchGrade 변경 effect가 둘 다
  // 마운트 시 실행되는데, 그 둘 다 이 state를 거치게 해야 어느 쪽이 나중에 이겨도 필터가 남는다.
  const [searchWorkEmp] = useState(searchParams.get('workEmp') || '');
  const [searchOpenOnly] = useState(searchParams.get('openOnly') || '');

  const { techs, error, loading } = useSelector(({ techModule, loading }) => ({
    techs: techModule.reqTechs.techs,
    error: techModule.reqTechs.error,
    loading: loading['tech/LIST_REQ_TECHS'],
  }));

  useEffect(() => {
    dispatch(listReqTechs({ workEmp: searchWorkEmp || undefined, openOnly: searchOpenOnly || undefined }));

    return () => {
      unloadReqTechs();
    }
  }, []);

  const searchList = (values) => {

    const startDate =
      values.searchStrtDt !== null && values.searchStrtDt !== ''
        ? dayjs(values.searchStrtDt).format('YYYY-MM-DD')
        : '';
    const endDate =
      values.searchEndDt !== null && values.searchEndDt !== ''
        ? dayjs(values.searchEndDt).format('YYYY-MM-DD')
        : '';

    let searchData = {
      reqGrade: searchGrade,
      [searchKeyword]: values.searchWords,
      strtDt: startDate,
      endDt: endDate,
      // 홈 위젯 딥링크 필터(메인화면 재검토, 2026-10-23) - 비어 있으면 서버가 무시한다.
      workEmp: searchWorkEmp || undefined,
      openOnly: searchOpenOnly || undefined,
    };

    setSearchKeyword(values.searchKeyword);
    setSearchWords(values.searchWords);
    setSearchStrtDt(values.searchStrtDt);
    setSearchEndDt(values.searchEndDt);

    dispatch(listReqTechs(searchData));

  }


  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
        disableExport: true,
      },
      {
        field: 'prjUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,

      },
      {
        field: 'reqUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'reqStatus',
        headerName: '작업상태',
        minWidth: 150,
        flex: 0.8,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: TechReqStatusChip,
      },

      {
        field: 'custNm',
        headerName: '고객명',
        minWidth: 240,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'left',
        headerAlign: 'center',
      },
      {
        field: 'custEmpNm',
        headerName: '고객 담당자',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'workTyp',
        headerName: '작업종류',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'workStDt',
        headerName: '작업요청시작일',
        minWidth: 120,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'workEdDt',
        headerName: '작업요청종료일',
        minWidth: 120,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'workEmpNm',
        headerName: '작업자',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'left',
        headerAlign: 'left',

      },
      {
        field: 'crtNm',
        headerName: '작성자',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
      },
      {
        field: 'crtDt',
        headerName: '작성일',
        minWidth: 180,
        flex: 0.8,
        type: 'string',
        editable: false,
      },
    ],
    [],
  );

  const handleRowClick = (param, event) => {
    navigate(`/reqtechmng/${param.id}`)
  };

  const initialValues = {
    searchKeyword: searchKeyword,
    searchWords: searchWords,
    searchStrtDt: searchStrtDt,
    searchEndDt: searchEndDt,
  };


  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
    searchStrtDt: yup.date().nullable().default(undefined),
    searchEndDt: yup
      .date()
      .min(yup.ref('searchStrtDt'), '등록 종료일을 확인하세요')
      .when('searchStrtDt', (searchStrtDt, schema) => {
        if (searchStrtDt) return schema.required('등록 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      setTimeout(() => {
        searchList(values);
        setSubmitting(false);
      }, 1000);
    },
  });

  useEffect(() => {
    searchList(formik.values);
  }, [searchGrade])

  const onChangeGrade = (grade) => {

    if (grade === searchGrade) {
      grade = "";
    }

    setSearchGrade(grade);
  }

  // 검색 카드 "초기화" - 이 화면은 별도 reset 액션이 없고 로컬 state라, 초기값으로
  // 직접 되돌리고 다시 조회한다(2026-10-22, taxIssuedmng과 동일한 패턴).
  const handleReset = () => {
    setSearchGrade('');
    searchList({ searchKeyword: 'custNm', searchWords: '', searchStrtDt: '', searchEndDt: '' });
  };

  return (
    <>
      <BreadcrumbsContainer title="기술지원/작업지원 요청 관리/요청 리스트" icon="tech" />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        <TechReqListBox formik={formik} onReset={handleReset} />
        <TechReqStatusList searchGrade={searchGrade} onChangeGrade={onChangeGrade} />
        <TechList
          reqStatus
          columns={columns}
          rows={techs}
          loading={loading}
          handleRowClick={handleRowClick}

          columnVisibilityModel={{
            id: false,
            reqUuid: false,
            prjUuid: false,
          }}
        />
      </Box>
    </>
  );
};

export default ReqTechListContainer;
